export const environment = {
   production: false,
   basePath: 'https://mieventtransapi.mi2.in/api',
   tenant: 'T00001',
   supportedCountry: ['IN','US'],
   version: 'v 2.1.0',
   passwordSecretKey: 'GDuVuFTh5NOmsBqebXm0edBpLHLa22dlzcoEi9wqcaI=',
   domainURL: "http://localhost:4200/#/signin"
};
